import React, { FC } from 'react';


import { COLORS } from '../../config/designSystem/Colors';
import { Caption3Bold } from '../../config/designSystem/typography';
import { NavigationIcon } from './NavigationIcon';
import { NavigationPanelTabElementProp } from './NavigationPanelTabElement';
import { SPACING } from '../../config/designSystem/Spacing';
import { TouchableOpacity, View } from 'react-native';
import { useDrawerLabel } from '../../hooks/navigation/useDrawerLabel';
import { useNavigationOnPress } from '../../hooks/navigation/useNavigationOnPress';


const NavigationTabItem: FC<NavigationPanelTabElementProp> = ({labelKey, selected}) => {

  const label =  useDrawerLabel(labelKey);
  const {onPress} = useNavigationOnPress(labelKey);

  const renderText = () => {
    return <Caption3Bold align color={selected?COLORS.content.accent:COLORS.content['tertiary']}>{label}</Caption3Bold>;
  };




  return(
    <TouchableOpacity onPress={onPress} style={{alignItems: 'center'}}>
      <View style={{rowGap:SPACING['sp-4'], alignItems: 'center'}}>
        <NavigationIcon labelKey={labelKey} selected={selected} size={24}/>
        {renderText()}
      </View>
    </TouchableOpacity>
  );
};



export default NavigationTabItem;